//genralUtils.js
import { parseISO, format } from 'date-fns';

export function dateExpired(inputDateStr) {
    // Get the current date in UTC
    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

    // Create a Date object from the input string in UTC
    const inputDate = new Date(`${inputDateStr}T00:00:00Z`);

    // Return true if today's date is after the input date
    return today > inputDate;
}

export const formatDate = (isoDateString, showTime = true) => {
  const date = parseISO(isoDateString); // parse the ISO string
  return showTime ? format(date, "PPpp") : format(date, "PP"); // e.g., 'Oct 2, 2024, 7:30 PM' or 'Oct 2, 2024'
};


export function isRTL(lang) {
  // Expand this list if you support other RTL languages
  const rtlLangs = ['Hebrew', 'Arabic', 'Farsi', 'Urdu'];
  return rtlLangs.includes(lang);
}

